export default ['global'].map(i => `/${i}`);
